module.exports = __webpack_public_path__ + "img/hw_token.4018f27b.jpeg";